import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { ProgramTypeRef } from "./ProgramTypeRef";
import type { ProgramTypeStaff } from "./ProgramTypeStaff";
import type { RatingChangeDTOBase } from "./RatingChangeDTOBase";
import type { RatingRef } from "./RatingRef";
import type { RatingStaff } from "./RatingStaff";
import type { TrackedBase } from "./TrackedBase";

export class RatingChangeStaff implements RatingChangeDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly changeId: number, public readonly personId: PersonStaff | null, public readonly ratingId: RatingStaff | null, public readonly programId: ProgramTypeStaff | null, public readonly classRatingAssignId: number | null, public readonly action: string | null, public readonly changedBy: string | null, public readonly changedDate: Date, public readonly comments: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly ratingIdTargetIds: RatingRef | null, public readonly programIdTargetIds: ProgramTypeRef | null, public readonly ratingName: string | null, public readonly ratingCategory: string | null, public readonly programName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.ratingIdLoaded = this.ratingId != null;
    this.ratingIdCached = this.ratingId;
    this.programIdLoaded = this.programId != null;
    this.programIdCached = this.programId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private ratingIdLoaded: boolean;
  private ratingIdCached: RatingStaff | null;
  private programIdLoaded: boolean;
  private programIdCached: ProgramTypeStaff | null;
  async personIdLazy(): Promise<PersonStaff | null> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getRatingChangeStaffPersonId(this.changeId);
      this.personIdLoaded = true;
    }
    return this.personIdCached;
  }
  async ratingIdLazy(): Promise<RatingStaff | null> {
    if (!this.ratingIdLoaded) {
      this.ratingIdCached = await (this.ratingIdTargetIds != null ? this.cbiServiceContext!.ratingService().getRatingStaff(this.ratingIdTargetIds.ratingId) : Promise.resolve(null));
      this.ratingIdLoaded = true;
    }
    return this.ratingIdCached;
  }
  async programIdLazy(): Promise<ProgramTypeStaff | null> {
    if (!this.programIdLoaded) {
      this.programIdCached = await (this.programIdTargetIds != null ? this.cbiServiceContext!.programTypeService().getProgramTypeStaff(this.programIdTargetIds.programId) : Promise.resolve(null));
      this.programIdLoaded = true;
    }
    return this.programIdCached;
  }
}
